// extracted by mini-css-extract-plugin
export var appContainer = "QdrUx";
export var bleedThrough = "dPXfr";
export var main = "NzIuH";
export var mainContainer = "Flvp1";
export var monarchAwareBackground = "UU8iG";
export var positionRelative = "zloVf";